import { render, staticRenderFns } from "./BSelect.vue?vue&type=template&id=0bca1220"
import script from "./BSelect.vue?vue&type=script&lang=js"
export * from "./BSelect.vue?vue&type=script&lang=js"
import style0 from "./BSelect.vue?vue&type=style&index=0&id=0bca1220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports